import { renderComponent } from '@/utils/tools';
import LangMenu from '@/components/LangMenu';
import Cookie from '@/components/Cookie';
import Sidebar from '@/components/Sidebar';
import initSearchMobile from '../home/searchMobile';
import initSeoLinks from '../shared/seoLinks';
import initSeoContent from '../shared/seoContent';

import initGAEvents from './events';
import initSubscribeForm from './subscribe';

interface GlobalConfig {
  lang?: string;
}

const initGlobal = ({ lang }: GlobalConfig): void => {
  initGAEvents();
  renderComponent(LangMenu);
  renderComponent(Cookie);
  renderComponent(Sidebar);
  initSearchMobile(lang ?? '');
  initSubscribeForm(lang ?? '');
  initSeoLinks();
  initSeoContent();
};

export default initGlobal;
